module.exports = __webpack_public_path__ + "static/fonts/iconfont.28aacfb2.ttf";